import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Features/Status_LED/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import StatusTable from 'components/Web_User_Interface/1440p_Series/Features/Status_LED/statusTable';
import SignalTable from 'components/Web_User_Interface/1440p_Series/Features/Status_LED/signalTable.jsx';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Features Menü // Status LED",
  "path": "/Web_User_Interface/1440p_Serie/Features/Status_LED/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Haben Sie die blinkende, blaue LED an der Kamera erkannt? Die kann in einem dunklen Raum sehr nerven. Aber es kann dazu dienen, Probleme mit Ihrer Netzwerkverbindung zu beheben oder Personen darauf aufmerksam machen, dass Sie gefilmt werden. Für alle anderen Zwecke können Sie die LED hier deaktivieren.",
  "image": "./WebUI_1440p_SearchThumb_Features_Status_LEDs.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Features_Status_LEDs.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Features Menü // Status LED' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Haben Sie die blinkende, blaue LED an der Kamera erkannt? Die kann in einem dunklen Raum sehr nerven. Aber es kann dazu dienen, Probleme mit Ihrer Netzwerkverbindung zu beheben oder Personen darauf aufmerksam machen, dass Sie gefilmt werden. Für alle anderen Zwecke können Sie die LED hier deaktivieren.' image='/images/Search/WebUI_1440p_SearchThumb_Features_Status_LEDs.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Features_Status_LEDs.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Features/Status_LED/' locationFR='/fr/Web_User_Interface/1440p_Series/Features/Status_LED/' crumbLabel="Status LED" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "features-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#features-men%C3%BC",
        "aria-label": "features menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "deaktivieren-sie-die-netzwerk-led-ihrer-kamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#deaktivieren-sie-die-netzwerk-led-ihrer-kamera",
        "aria-label": "deaktivieren sie die netzwerk led ihrer kamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Deaktivieren Sie die Netzwerk LED Ihrer Kamera`}</h3>
    <p><em parentName="p">{`(falls in Ihrem Kameramodell verfügbar)`}</em></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/399b69093876a02c3dd1bf3cf0333d2b/2e367/1440p_Settings_Features_Status_LED.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "47.39130434782609%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACEklEQVQoz2XQP08TYQDH8b4PFjS09D9GEwO93v9ee0Dp3XNXek1LA1opCNoBEmwRxYTBGF1MXDRx0IQwKQzoogmyOBDj4BvwpXzNHRISHT55bnjyze+5WD6fJ5vNks3lSI5dQWsPEHtfmN3+SHlwGKkMjqgM/xocMT08pP38G+rCDoo0SS4/wcjICKOjo8TS6TShTCZDfOwqejWg3d8juLtDc+1xpLG6g788pN7bjvh3tghWHmD7SxQmJaamity4fjMSC0MX4okEmiLRDnyadZeGXyPwHepuFTE3g6jNIqoVvKCD33tIzfFQ5BJy0UBTSxQl7XJhKB6Po2k6rXabRtBECA9XeAjPR7gOwpnDnbOprj6h9uyUemsV26iiqTqKbFAoKMRSqVS07jKoMT8/jxACz/POCRe/1aXe3aTZ6tKvuay7Hre8Bgueg2WpqLKJVFDPgxcLE4kEsizjui6O4yDCkC+iZf7tDeobL+ksbfLUttk1K/Q7gns9C7usIhd1ZOmf4Pl3iomJaxiahWWWaAbTzEyXsC0dVZrC1GRmqmWGjwYc7b/i/qKJripYho4qy5dPDs/Q+Pg4mXQ2+ich27awShq6ptPtNOivr/H+3Vt+/fzO75OvvN5YQVUKlE2dYlH+f2EymSSTyUUxVdExDQtTN1heXODgzQsOjz/x4+yUkw/7nH0+5mB3C68iR3eLksIfLvVYF/veVm8AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/399b69093876a02c3dd1bf3cf0333d2b/e4706/1440p_Settings_Features_Status_LED.avif 230w", "/de/static/399b69093876a02c3dd1bf3cf0333d2b/d1af7/1440p_Settings_Features_Status_LED.avif 460w", "/de/static/399b69093876a02c3dd1bf3cf0333d2b/7f308/1440p_Settings_Features_Status_LED.avif 920w", "/de/static/399b69093876a02c3dd1bf3cf0333d2b/730d0/1440p_Settings_Features_Status_LED.avif 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/399b69093876a02c3dd1bf3cf0333d2b/a0b58/1440p_Settings_Features_Status_LED.webp 230w", "/de/static/399b69093876a02c3dd1bf3cf0333d2b/bc10c/1440p_Settings_Features_Status_LED.webp 460w", "/de/static/399b69093876a02c3dd1bf3cf0333d2b/966d8/1440p_Settings_Features_Status_LED.webp 920w", "/de/static/399b69093876a02c3dd1bf3cf0333d2b/fbb05/1440p_Settings_Features_Status_LED.webp 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/399b69093876a02c3dd1bf3cf0333d2b/81c8e/1440p_Settings_Features_Status_LED.png 230w", "/de/static/399b69093876a02c3dd1bf3cf0333d2b/08a84/1440p_Settings_Features_Status_LED.png 460w", "/de/static/399b69093876a02c3dd1bf3cf0333d2b/c0255/1440p_Settings_Features_Status_LED.png 920w", "/de/static/399b69093876a02c3dd1bf3cf0333d2b/2e367/1440p_Settings_Features_Status_LED.png 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/399b69093876a02c3dd1bf3cf0333d2b/c0255/1440p_Settings_Features_Status_LED.png",
              "alt": "Web User Interface - 1440p Series - Features Status LED",
              "title": "Web User Interface - 1440p Series - Features Status LED",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <StatusTable mdxType="StatusTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Hier können Sie das Verhalten der roten und blauen Status LED an der Stromversorgung Ihrer Kamera einstellen. Aktivieren Sie es um die Kamera Aktivität anzuzeigen - gerade während der Installation nützlich. Oder deaktivieren Sie es bei der normalen Verwendung.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <SignalTable mdxType="SignalTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Im normalen Betrieb blinkt nur die rote LED und die blaue LED leuchtet entweder (bei `}<strong parentName="p">{`WLAN Verbindung`}</strong>{`) oder ist aus bei `}<strong parentName="p">{`LAN Verbindung`}</strong>{`. Wenn die `}<strong parentName="p">{`WLAN Verbindung unterbrochen`}</strong>{` ist, beginnt die blaue LED schnell blinken.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Hinweis`}</strong>{`: Sollten die Status-LEDs trotz Deaktivierung weiterhin blinken oder leuchten, liegt das daran, dass die Kamera in Apple Home eingebunden ist und die Home-App die LEDs steuert. Bitte schalten Sie sie daher direkt in der Home-App aus.`}</li>
    </ul>
    <h2 {...{
      "id": "kamera-reset--wps",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#kamera-reset--wps",
        "aria-label": "kamera reset  wps permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Kamera Reset & WPS`}</h2>
    <p>{`Wenn Sie die Reset-Taste an Ihrer Kamera drücken, werden die Status-LEDs ausgeschaltet und...`}</p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Nach 3s`}</strong>{`: Schalten sich die blaue Status-LED ein und es startet, nach dem Loslassen der Taste, der `}<a parentName="li" {...{
          "href": "/de/Web_User_Interface/1440p_Serie/Netzwerk/WLAN/"
        }}>{`Wireless-Protected-Setup`}</a>{` Modus oder `}<strong parentName="li">{`WPS`}</strong>{`, mit dem Sie Ihre Kamera zu Ihrem lokalen WiFi hinzufügen können. Die blaue LED beginnt dann langsam zu blinken, was bedeutet das die Kamera versucht sich per WPS zu verbinden. Sobald die Verbindung erfolgreich hergestellt wurde, wird die blaue LED durchgehend leuchten. Sollte eine bestehende WLAN Verbindung unterbrochen werden, würde die blaue LED schnell blinken.`}</li>
      <li parentName="ol"><strong parentName="li">{`Nach 15s`}</strong>{`: Beginnt die blaue Status-LED langsam zu blinken und es werden, nach dem Loslassen der Taste, alle Kameraeinstellungen `}<strong parentName="li">{`mit Ausnahme der Netzwerkkonfiguration`}</strong>{` zurückgesetzt.`}</li>
      <li parentName="ol"><strong parentName="li">{`Nach 20s`}</strong>{`: Beginnt die blaue Status-LED schnell zu blinken und es werden, nach dem Loslassen der Taste, `}<strong parentName="li">{`ALLE`}</strong>{` Kameraeinstellungen zurückgesetzt.`}</li>
      <li parentName="ol"><strong parentName="li">{`Nach 30s`}</strong>{`: Geht die blaue Status-LED aus und die Kamera wird in den Zustand vor dem letzten Firmware-Update zurückgesetzt. Anschließend startet die Kamera neu.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      